module.exports = __webpack_public_path__ + "media/images/clients/zalo_btn_share-3e2bb7df911d8b957d7814704b5d4923.png";